import React from 'react';
import { useAppDispatch, useAppSelector, useTranslate, useWidgetsTheme as theme } from '@src/core/hooks';
import { currentProductAdderStatus, previousProductAddStep } from '@src/stores/product';
import { useWidgetId } from '@src/core/IdProvider';
import { OutlinedButton } from '@src/components/reusable';

const ProductAdderPreviousStepButton = () => {
  const widgetId = useWidgetId();
  const status = useAppSelector(currentProductAdderStatus(widgetId));
  const dispatch = useAppDispatch();
  const actionColor = theme('actionColor');
  const { i18n } = useTranslate();

  const handleGoBack = () => dispatch(previousProductAddStep(widgetId));

  return (
    <OutlinedButton color={actionColor} onClick={handleGoBack} disabled={status === 'adding_to_cart'}>
      {i18n('adder_goBackFooter')}
    </OutlinedButton>
  );
};

export default ProductAdderPreviousStepButton;
